// Edge-safe constants for the "dpid" (distinct person id) cookie used by
// middleware (Edge), the analytics route handler (Node), and the consent
// module (client). Keep this file free of `next/headers`, `node:*`, or any
// other runtime-specific imports so it can be imported from any module graph.

export const DPID_COOKIE_NAME = "dpid";
export const DPID_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365 * 2;
